import { ReactElement } from "react";
import { ContactStateEnum, outcomeLabelMap, stateInfoMap } from "../../../pages/targetList/dto";
import { CheckCircleIcon } from "../../../ui/icons/checkCircle";
import { SelectCustom } from "../../../ui/molecules/select";
import { AccordionFilter } from "../../../ui/organisms/accordionFilter";
import { FindAllContactsFilters } from "../dto";
import { keycloak } from "../../keycloak";

interface Props {
    updateFilters: (filter: Partial<FindAllContactsFilters>) => void
    filters: FindAllContactsFilters
}

export function OutcomeFilter(props: Props) {
    const { updateFilters, filters } = props

    // const [outComes, setOutComes] = useState<ContactStateEnum[]>([])
    // const [info, setInfo] = useState<string[]>([])
    // const [visibleOptions, setVisibleOptions] = useState<string[]>([])

    function generateOutcomeForFilters() {
        const outcomes = Object.values(ContactStateEnum);
        const outcomeLabelMap = new Map<ContactStateEnum, string>([
            [ContactStateEnum.DRAFT, "Da lavorare"],
            [ContactStateEnum.LEADTAKEN, "Lead preso"],
            [ContactStateEnum.TORECALL, "Da richiamare"],
            [ContactStateEnum.KO, "Ko"],
            [ContactStateEnum.INCORRECT, "Info errate"],
        ]);

        let filterOption: { label: ReactElement; value: string }[] = []
        outcomes.forEach(out => {
            if (!(out === ContactStateEnum.INCORRECT && keycloak.hasRealmRole('customer')))
                filterOption.push({ label: <div className="text-text-sm font-semibold text-neutral-800">{outcomeLabelMap.get(out)!}</div>, value: out.toString() })
            const microOutcomes = stateInfoMap(out);
            if (!(out === ContactStateEnum.INCORRECT && keycloak.hasRealmRole('customer')))
                microOutcomes.forEach((micro) => {
                    let microLabel = micro;
                    filterOption.push({ label: <div className="text-text-sm text-neutral-600 pl-4">{microLabel}</div>, value: micro })
                });

        })
        return filterOption
    }

    // useEffect(() => {
    //     if (info.length === 0 && filters.outcomeInfo.length === 0) {
    //         return
    //     } else
    //         updateFilters({ outcomeInfo: info.map(i => ({ label: i, value: i })) })
    // }, [info])

    // useEffect(() => {
    //     if (outComes.length === 0 && filters.outcome.length === 0) {
    //         return
    //     } else
    //         updateFilters({ outcome: outComes.map(i => ({ label: i, value: i })) })
    // }, [outComes])

    return (
        <AccordionFilter
            key={"person-filter-outcome-info"}
            label={"Esiti"}
            icon={<CheckCircleIcon color={""} size={0} />}
            showClear={filters.outcome.length > 0 || filters.outcomeInfo.length > 0}
            clearAction={() => { updateFilters({ outcome: [], outcomeInfo: [] }); }}
            deleteFilter={(option) => {
                updateFilters({ outcome: filters.outcome.filter(name => name.value !== option.value), outcomeInfo: filters.outcomeInfo.filter(name => name.value !== option.value) })

            }}
            options={[...filters.outcomeInfo, ...filters.outcome.map(out => ({ value: out.value, label: outcomeLabelMap.get(out.value as ContactStateEnum)! })) ?? []]}
        >
            <SelectCustom
                placeholder={"Seleziona un esito"}
                hideSelectedOptions={false}
                options={generateOutcomeForFilters()}
                isMulti
                defaultValue={filters.outcomeInfo.map(filter => filter.value).concat(filters.outcome.map(out => out.value)) ?? []}
                onChange={e => {
                    if (e?.length === 0) {
                        updateFilters({ outcome: [], outcomeInfo: [] })
                        return
                    }
                    if (e !== undefined && typeof e !== 'string') {
                        if (filters.outcome.concat(filters.outcomeInfo).length < e.length) {
                            const index = e.length - 1
                            const lastAdded = e[index]
                            if (lastAdded === ContactStateEnum.DRAFT || lastAdded === ContactStateEnum.LEADTAKEN) {
                                updateFilters({ outcome: [...filters.outcome, { label: outcomeLabelMap.get(lastAdded)!, value: lastAdded }] })
                            } else if (lastAdded === ContactStateEnum.INCORRECT || lastAdded === ContactStateEnum.KO || lastAdded === ContactStateEnum.TORECALL) {
                                updateFilters({
                                    outcome: [...filters.outcome, { label: outcomeLabelMap.get(lastAdded)!, value: lastAdded }],
                                    outcomeInfo: [...filters.outcomeInfo, ...stateInfoMap(lastAdded).map(info => ({ label: info, value: info }))]
                                })
                            } else {
                                updateFilters({
                                    outcomeInfo: [...filters.outcomeInfo, { label: lastAdded, value: lastAdded }]
                                })
                            }
                        }
                        else {
                            const removed = filters.outcome.concat(filters.outcomeInfo).find(el => !e.includes(el.value))?.value
                            if (removed === ContactStateEnum.DRAFT || removed === ContactStateEnum.LEADTAKEN) {
                                updateFilters({
                                    outcome: [...filters.outcome.filter(el => el.value !== removed)],
                                })
                            } else if (removed === ContactStateEnum.INCORRECT || removed === ContactStateEnum.KO || removed === ContactStateEnum.TORECALL) {
                                updateFilters({
                                    outcome: [...filters.outcome.filter(el => el.value !== removed)],
                                    outcomeInfo: [...filters.outcomeInfo.filter(el => stateInfoMap(removed).map(info => ({ label: info, value: info })))]
                                })
                            } else {
                                updateFilters({
                                    outcomeInfo: [...filters.outcomeInfo.filter(el => el.value !== removed)]
                                })
                            }
                        }
                    }
                }}
            />
        </AccordionFilter>
    )
}